import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for transport locations
 */
export class TransportLocationService {
  private resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.TransportLocations.TransportLocationResponse | InterACT.Interfaces.TransportLocations.TransportLocationsResponse>>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/transport-locations/:locationId');
  }

  /**
   * A method that creates the supplied transport location via a service call
   * @param transportLocation the transport location to be created
   */
  public create(transportLocation: InterACT.Interfaces.TransportLocations.TransportLocation) {
    return this.resource.save(transportLocation).$promise;
  }

  /**
 * A method that deletes the supplied transport location via a service call
 * @param transportLocation the transport location to be created
 */
  public delete(transportLocation: InterACT.Interfaces.TransportLocations.TransportLocation) {
    return this.resource.delete({ locationId: transportLocation.id }).$promise;;
  }

  /**
   * Function to retrieve a list of transport locations
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param query the query to execute against the dataset
   * @returns A http promise
   */
  public getList(page: number, perPageCount: number, query?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return <ng.IPromise<InterACT.Interfaces.TransportLocations.TransportLocationsResponse>>this.resource.get(options).$promise;
  }

  /**
 * Function to retrieve a single transport location
 *
 * @param id The id of the transport location to retrieve
 * @returns A http promise
 */
  public getTransportLocation(id: string) {
    return this.resource.get({ locationId: id }).$promise.then((resource) => {
      return (<InterACT.Interfaces.TransportLocations.TransportLocationResponse>resource).transportLocation;
    });
  }
}
